import type { Author } from "../../api/api";

interface AuthorProps {
	authors: Array<Author>;
}

export const AuthorsSimplyList = ({ authors }: AuthorProps): JSX.Element => {
	return (
		<>
			{authors.map((author) => (
				<div key={author.WP_user_ID} className="flex text-sm mb-2">
					<img
						alt={author.display_name}
						className="my-auto h-10 w-10 rounded-full"
						src={author.profile_picture}
					/>
					<div className="flex flex-col">
						<span className="ml-3 my-auto">{author.display_name}</span>
						<span className="ml-3 my-auto">{author.position}</span>
						<a className="ml-3 my-auto" href={"mailto:kontakt@akademialtca.pl"}>
							kontakt@akademialtca.pl
						</a>
					</div>
				</div>
			))}
		</>
	);
};
